/**
 * Функция, определяющая таймаут, через который тост будет скрыт.
 * @param hideDelay - значение таймаута конкретного тоста
 * @param globalHideDelay - значение извне (параметры хука "useToast" при инициализации, либо его дефолтное значение)
 * @returns рассчитанное значение таймаута
 */
export function calculateHideDelay(hideDelay, globalHideDelay) {
  /**
   * Берём значение времени скрытия тоста:
   * 1. из настроек тоста, если они переданы
   * 2. из настроек хука, там оно всегда есть (либо передано, либо дефолт)
   */
  const calculatedDelay = hideDelay !== null && hideDelay !== void 0 ? hideDelay : globalHideDelay;
  return calculatedDelay;
}